var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 24,
    viewBox: "0 0 84 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93934 10.9393C8.35355 11.5251 8.35355 12.4749 8.93934 13.0607L18.4853 22.6066C19.0711 23.1924 20.0208 23.1924 20.6066 22.6066C21.1924 22.0208 21.1924 21.0711 20.6066 20.4853L12.1213 12L20.6066 3.51471C21.1924 2.92893 21.1924 1.97918 20.6066 1.39339C20.0208 0.807607 19.0711 0.807607 18.4853 1.39339L8.93934 10.9393ZM74 10.5L10 10.5L10 13.5L74 13.5L74 10.5Z",
    fill: "#3D4970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageArrow);
export default __webpack_public_path__ + "static/media/pageArrow.f7b573ee37983c85eb214043ea80dc45.svg";
export { ForwardRef as ReactComponent };